import {debugLog} from "./LogUtils";
import {generateJSON} from "../JSONGeneration/JSONGeneration";
import {enrolmentValidation, stateWithPlan2AsPrimary} from "./PlanUtils";
import {generateQuote} from "../Quotes/QuoteGenerator";

//Load the URL from the environment variable, but if it's not set then default to localhost
const baseUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

export const endpoints = {
    login: 'auth/login',
    logout: 'auth/logout',
    refresh: 'auth/refresh'
}

// Makes a request to the backend API, without caching
// endpoint: the endpoint to call (e.g. 'auth/login')
// method: the HTTP method to use (e.g. 'GET', 'POST', 'PUT', 'DELETE')
// data: the data to send in the request body as a javascript object
// allowRefresh: whether to allow the function to automatically attempt to refresh the token if the response is 401
// returns a promise that resolves to the response data
export const apiRequest = async (endpoint, method='GET', data = null, allowRefresh=true) => {

    debugLog("api to :", `${baseUrl}/${endpoint}`);

    let options = {
        credentials: 'include', // Important: include credentials to send the cookie
        method: method,
        headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate', // Prevent caching
            'Pragma': 'no-cache', // Compatibility with HTTP 1.0
            'Expires': '0' // Proxies should not cache
        },
    }

    if (method !== 'GET' && data) {
        options['body'] = JSON.stringify(data);
    }

    return fetch(`${baseUrl}/${endpoint}`, options)
        .then(response => {

            //Attempt to refresh the token and retry if the response is 401
            if (response.status === 401 && allowRefresh) {
                //Attempt to refresh the token
                debugLog('Attempting to refresh access token');
                return apiRequest(`auth/refresh`, 'GET',null, false)
                    .then(refreshedResponse => {
                        if (refreshedResponse.success) {
                            debugLog('Token refreshed');
                            //Only retry the request one time though
                            return apiRequest(endpoint, method, data, false);
                        } else {
                            throw new Error('Token refresh failed');
                        }
                    });
            }

            if (!response.ok) {
                // Create an error object and include the status code
                let error = new Error(`Network Error during API response from ${endpoint}`, {cause: response});
                error.statusCode = response.status;
                throw error;
            }
            return response.json();
        })
        .catch(error => {
            throw error;
        });
}

// Logs the user out
export const logout = async () => {
    return apiRequest(endpoints.logout)
        .then(response => {
            if (response.success) {
                debugLog(response);
                //navigate("/login");
            }
            //TODO: handle other case?
        }).catch(error => {
            console.error('There was a problem trying to logout.', error);
        });
}

export const status = async () => {
    return apiRequest('auth/status');
}

export const saveEnrollment = async (data) => {
    const postData = {
        ...data,
        _id: data.enrollment._id, //application._enrollmentId,
        validated: enrolmentValidation(data).length === 0,
        quoteData: generateQuote(data) || {},
        quoteDataPlan2: generateQuote(stateWithPlan2AsPrimary(data)) || {},
    }

    return apiRequest('api/enrollment', 'POST', postData)
        .then(response => {
            debugLog(response); // Handle success response
            if (!response._id) {
                //TODO: this needs to be better
                //alert("There was a problem saving your application. Please try again later.");
                data.setEnrollment({
                    ...data.enrollment,
                    lastSaveAttemptSuccessful: false,
                });
                return;
            }

            //If we don't have an _id, replace the URL with the new one
            //This is because we are saving for the first time
            if (!postData._id) {
                window.history.replaceState("", "Enrolment", "/enrolment/" + response._id);
            }

            //Artificially add the _id to the data object
            // This could be done better!
            /*
            data.setApplication({
                ...data.application,
                _enrollmentId: response._id
            });
             */
            data.setEnrollment({
                ...data.enrollment,
                _id: response._id,
                state: response.state,
                validated: response.validated,
                lastSuccessfulSaveTime: new Date(),
                lastSaveAttemptSuccessful: true,
            });

            return response;

        }).catch(error => {
            console.error('There was a problem with your fetch operation:', error);
            data.setEnrollment({
                ...data.enrollment,
                lastSaveAttemptSuccessful: false,
            });
            throw error;
        });

}